let sideMenu;

function openMenu() {
  document.body.classList.remove('menu-closed');

  sideMenu.classList.add('in');

  document.body.classList.add('side-menu-open');
  document.body.appendChild(
    <div class="navbar-backdrop" />
  );
}

function closeMenu() {
  if (!sideMenu.classList.contains('in')) {
    return;
  }

  sideMenu.classList.remove('in');
  document.body.classList.remove('side-menu-open');

  document.querySelector('.navbar-backdrop')?.remove();
}

function init() {
  sideMenu = document.querySelector('.side-menu');

  let windowWidth = getWindowWidth();

  document.querySelector('.navbar .navbar-toggle').addEventListener('click', e => {
    e.preventDefault();

    if (sideMenu.classList.contains('in')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  document.body.addEventListener('click', e => {
    if (!e.target.matches('.navbar-backdrop')) {
      return;
    }

    closeMenu();
  });

  window.addEventListener('resize', () => {
    const newWidth = getWindowWidth();
    if (newWidth === windowWidth) {
      return;
    }

    windowWidth = newWidth;

    closeMenu();
  });
}

function getWindowWidth() {
  return document.documentElement.clientWidth;
}

export default {
  init,
  openMenu,
  closeMenu
};
